<template>
  <div>
    <shared-table
      is-instagram
      :config="config"
      title="instagram.accounts"
    />
  </div>
</template>

<script>
import SharedTable from '@/views/admin/pages/SharedTable'
import AccountsTableConfig from './config/accounts-table-config'

export default {
  components: {
    SharedTable,
  },
  data() {
    return {
      config: AccountsTableConfig,
    }
  },
}
</script>
